import React from "react";
import PageHeadline from "../../components/shared/PageHeadline";
import { useTranslation } from "react-i18next";
import ImageEarlyBird from "../../assets/images/registration-eb.png";
import ImageReguler from "../../assets/images/registration-reguler.png";
import ImageGroup from "../../assets/images/registration-group-2.png";

export default function RegistrationMenu() {
  const { t } = useTranslation();

  const items = [
    {
      img: ImageEarlyBird,
      link: "/registration/early-bird",
      alt: "Early Bird Registration",
      disabled: true, // 👈 mark as disabled
    },
    {
      img: ImageReguler,
      link: "/registration/form",
      alt: "Reguler Registration",
      disabled: true, // 👈 mark as disabled
    },
    {
      img: ImageGroup,
      link: "/registration/form/#!/category/1958?qty=3",
      alt: "Group Registration",
      disabled: true,
    },
  ];

  return (
    <div className="text-white">
      <div className="relative min-h-[180px] lg:min-h-[300px] bg-brand-blue bg-contain md:bg-cover bg-no-repeat top-[56px] md:top-[109px] 2xl:top-[136px] flex justify-center items-center">
        <PageHeadline title={t("registrationTitle")} />
      </div>

      <div className="top-0 md:top-40 lg:top-60 relative bg-white 2xl:px-0 md:px-14 pb-36 md:pb-48 lg:pb-96 2xl:pb-44 lg:mb-24 px-4 md:px-0 justify-center flex flex-col items-center">
        <div className="mt-10 grid grid-cols-1 md:grid-cols-1 gap-6 md:gap-8 md:w-1/2">
          {items.map((item, index) => {
            const Wrapper = item.disabled ? "div" : "a";

            return (
              <Wrapper
                key={index}
                {...(!item.disabled && { href: item.link })}
                className={`block relative group overflow-hidden ${item.disabled ? "cursor-not-allowed" : ""
                  }`}
              >
                <img
                  src={item.img}
                  alt={item.alt}
                  className={`w-full h-full object-cover transition-transform duration-300 group-hover:scale-105 ${item.disabled ? "grayscale opacity-60" : ""
                    }`}
                />

                {item.disabled && (
                  <div className="absolute inset-0 bg-black/30 flex items-center justify-center font-poppins text-white text-lg font-semibold">
                    Sold Out
                  </div>
                )}
              </Wrapper>
            );
          })}
        </div>
      </div>
    </div>
  );
}
